import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=1ab12715&"
import script from "./ViewDocument.vue?vue&type=script&lang=js&"
export * from "./ViewDocument.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports